import React from 'react'
import { Cylinder } from '../geometries/Cylinder'

export const BarChair = ({ position }) => {
	return (
		<group position={position} scale={[1, 1, 1]} rotation={[0, 0, 0]} castShadow receiveShadow>
			<Cylinder color='#000' position={[0, 42, 0]} size={[15, 15, 2.5, 50]} />
			<Cylinder position={[0, 20, 0]} size={[2, 2, 40, 50]} />
			<Cylinder position={[0, 2, 0]} size={[1, 10, 4, 50]} />
		</group>
	)
}
